import useProjectId from 'hooks/useProjectId';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import userRoleId from 'hooks/useRoleId';
import useAuthSession from 'context/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRole?: number;
  redirectTo?: string;
}

/**
 * Makes a route private by checking everytime if the user has the required
 * permissions to view a certain route. otherwise it sends the user into
 * the home page
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredRole = 6, redirectTo }) => {
  const projectId = useProjectId();
  const navigate = useNavigate();
  const roleId = userRoleId();
  const authSession = useAuthSession();

  const redirect = () => navigate(redirectTo || `/${projectId}/`);

  useEffect(() => {
    try {
      const { token } = authSession;
      if (!token) throw new Error('No token found');

      if (roleId > requiredRole) redirect();
    } catch (err) {
      redirect();
      authSession.destroySession();
    }
  }, []);

  return <>{children}</>;
};

export default PrivateRoute;
